<div class="dialog">
  <h4 mat-dialog-title>{{ 'personal_access_token_dialog_title' | translate }}</h4>

  <form *ngIf="!token" [formGroup]="form" (ngSubmit)="create()">
    <mat-card>
      <mat-form-field>
        <mat-label>{{ 'common_field_label' | translate }}</mat-label>
        <input matInput formControlName="name" maxlength="100" required />
        <mat-hint>{{ 'personal_access_token_hint_name' | translate }}</mat-hint>
        <mat-error *ngIf="formCrls.name.invalid">{{ 'personal_access_token_error_name_required' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'personal_access_token_col_role' | translate }}</mat-label>
        <mat-select formControlName="rightId" required>
          <mat-option *ngFor="let right of eligibleRights" [value]="right.rightId">{{ right.profileCode }} - {{ right.perimeterName }}</mat-option>
        </mat-select>
        <mat-hint *ngIf="eligibleRights.length === 0">{{ 'personal_access_token_no_eligible_right' | translate }}</mat-hint>
        <mat-error *ngIf="formCrls.rightId.invalid">{{ 'personal_access_token_error_role_required' | translate }}</mat-error>
      </mat-form-field>
      <div class="role-warning" *ngIf="selectedRight && !selectedRight.opensProjects">{{ 'personal_access_token_role_without_projects' | translate }}</div>

      <div class="scopes">
        <div class="scopes-label">{{ 'personal_access_token_col_scopes' | translate }}</div>
        <mat-checkbox formControlName="projectsRead">
          {{ 'personal_access_token_scope_projects_read' | translate }} <code>{{ scopes.projectsRead }}</code>
        </mat-checkbox>
        <mat-checkbox formControlName="projectsWrite">
          {{ 'personal_access_token_scope_projects_write' | translate }} <code>{{ scopes.projectsWrite }}</code>
        </mat-checkbox>
        <mat-checkbox formControlName="catalogsWrite">
          {{ 'personal_access_token_scope_catalogs_write' | translate }} <code>{{ scopes.catalogsWrite }}</code>
        </mat-checkbox>
        <div class="scope-warning" *ngIf="formCrls.catalogsWrite.value && missingCatalogRights.length">
          {{ 'personal_access_token_role_without_catalog_rights' | translate: { resources: missingCatalogRights.join(', ') } }}
        </div>
        <div class="scopes-hint">{{ 'personal_access_token_hint_scopes' | translate }}</div>
        <mat-error *ngIf="form.errors?.scopeRequired">{{ 'personal_access_token_error_scope_required' | translate }}</mat-error>
      </div>

      <mat-form-field>
        <mat-label>{{ 'personal_access_token_field_expire_date' | translate }}</mat-label>
        <input matInput [matDatepicker]="expireDatePicker" [min]="minExpireDate" formControlName="expireDate" />
        <mat-datepicker-toggle matSuffix [for]="expireDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #expireDatePicker></mat-datepicker>
        <mat-hint>{{ 'personal_access_token_hint_expire_date' | translate }}</mat-hint>
      </mat-form-field>
    </mat-card>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="close()">{{ 'common_btn_cancel' | translate }}</button>
      <button type="submit" mat-button color="accent" [disabled]="form.invalid || saving">{{ 'personal_access_token_btn_create' | translate }}</button>
    </div>
  </form>

  <div *ngIf="token">
    <mat-card>
      <p class="warning">{{ 'personal_access_token_shown_once' | translate }}</p>
      <div class="token">
        <code>{{ token }}</code>
        <button mat-icon-button type="button" (click)="copy()" [title]="'personal_access_token_btn_copy' | translate">
          <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
        </button>
      </div>
    </mat-card>
    <div mat-dialog-actions>
      <button type="button" mat-button color="accent" (click)="close()">{{ 'common_close' | translate }}</button>
    </div>
  </div>
</div>
